import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c752f756"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "standard-card" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "desc"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "btn-group" }

import { computed } from 'vue'
export interface StandardCardProps {
  title: string
  desc?: {
    title: string
    texts: string[]
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'standard-card',
  props: {
    title: {},
    desc: {}
  },
  emits: ["preview", "download"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const hasDesc = computed(() => props.desc)
const emit = __emit

const preview = () => {
  emit('preview')
}

const download = () => {
  emit('download')
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", {
        class: "card-title",
        innerHTML: _ctx.title
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("main", {
      class: _normalizeClass({ has: hasDesc.value })
    }, [
      (hasDesc.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "desc-title",
              innerHTML: _ctx.desc.title
            }, null, 8, _hoisted_4),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desc.texts, (text, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(text), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          plain: "",
          color: "#3461FF",
          onClick: preview,
          class: "btn2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("预览")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          color: "#3461FF",
          onClick: download,
          class: "btn1"
        }, {
          default: _withCtx(() => [
            _createTextVNode("下载")
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}
}

})